export const AGENDA_COLORS = {
  NORMAL: "#3b82f6",
  RECALL: "#14b8a6",
  HELD: "#f97316",
  PLAN: "#0f766e",
  PLAN_HELD: "#ea580c"
}

export const getClinicColor = () => AGENDA_COLORS.NORMAL

export const resolveAgendaEventColors = ({
  isHeld,
  isPlanLinked,
  source,
  clinicName
}) => {
  if (isHeld && isPlanLinked) {
    return {
      backgroundColor: AGENDA_COLORS.PLAN_HELD,
      borderColor: AGENDA_COLORS.PLAN_HELD,
      textColor: "#ffffff"
    }
  }

  if (isHeld) {
    return {
      backgroundColor: AGENDA_COLORS.HELD,
      borderColor: AGENDA_COLORS.HELD,
      textColor: "#ffffff"
    }
  }

  if (isPlanLinked) {
    return {
      backgroundColor: AGENDA_COLORS.PLAN,
      borderColor: AGENDA_COLORS.PLAN,
      textColor: "#ffffff"
    }
  }

  if (source === "RECALL") {
    return {
      backgroundColor: AGENDA_COLORS.RECALL,
      borderColor: AGENDA_COLORS.RECALL,
      textColor: undefined
    }
  }

  return {
    backgroundColor: getClinicColor(clinicName),
    borderColor: getClinicColor(clinicName),
    textColor: undefined
  }
}